// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"443":"b4f29f05","7217":"0d16c88f"}[chunkId] + ".chunk.css";
};